import React from 'react';
import { useTable, useSortBy, useGlobalFilter } from 'react-table';
import { Table, Pagination, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Table.css';

const TableComponent = ({ columns, data, onPageChange, currentPage, Pages, hiddenPagination, loading, ActionLink, navigationColumn }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy
  );

  const handleNextPage = () => {
    if (currentPage < Pages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <div>
      <div className="table-container">
        <Table {...getTableProps()} striped bordered hover className='table'>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {loading ? (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  <Spinner size="sm" animation="border" />
                </td>
              </tr>
            ) : (
              rows.length > 0 ? (
                rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={i}>
                      {row.cells.map((cell, i) => (
                        <td
                          {...cell.getCellProps()}
                          key={i}
                          style={{ cursor: navigationColumn === cell.column.id ? 'pointer' : 'default' }}
                        >
                          {navigationColumn === cell.column.id ? (
                            <Link to={ActionLink(row.original)}>
                              {cell.render('Cell')}
                            </Link>
                          ) : (
                            typeof cell.value === 'string' &&( cell.value.endsWith('png')||cell.value.endsWith('jpg')) ? (
                              <img src={cell.value} alt="Image" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                            ) : (
                              cell.render('Cell')
                            )
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={columns.length} style={{ backgroundColor: "#fafafa" }} className="text-center">Empty list</td>
                </tr>
              )
            )}
          </tbody>
        </Table>
      </div>
      {!hiddenPagination && (
        <div className='pagination-table-com'>
          <Pagination>
            <Pagination.Prev onClick={handlePrevPage} disabled={currentPage === 1} />
            {[...Array(Pages).keys()].map(page => (
              <Pagination.Item
                key={page + 1}
                active={page + 1 === currentPage}
                onClick={() => onPageChange(page + 1)}
              >
                {page + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={handleNextPage} disabled={currentPage === Pages} />
          </Pagination>
        </div>
      )}
    </div>
  );
};

export default TableComponent;
